import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UserLoggedInGuard as AuthGuard } from './shared/guards/user-logged-in.guard';
import { HostContextService } from './services/host-context/host-context.service';

// Eager imports for MFE single-bundle compatibility (lazy chunks cause 404s in Polaris shell)
import { LoginModule } from './features/login/login.module';
import { ContactModule } from './features/contact/contact.module';
import { InfoModule } from './features/info/info.module';
import { LaboratoryModule } from './features/laboratory/laboratory.module';

// Determine routing strategy at module load time.
// DI is not available yet at module-definition time, but HostContextService has
// no dependencies, so instantiate it directly to reuse the single source of truth.
// Polaris uses path-based routing (Single-SPA manages it); dotcom uses hash routing.
const useHashRouting = !new HostContextService().isPolaris;
const routes: Routes = [
  {
    path: 'login',
    canActivate: [ AuthGuard ],
    loadChildren: () => Promise.resolve(LoginModule)
  },
  {
    path: 'contact',
    canActivate: [ AuthGuard ],
    loadChildren: () => Promise.resolve(ContactModule)
  },
  {
    path: 'info',
    canActivate: [ AuthGuard ],
    loadChildren: () => Promise.resolve(InfoModule)
  },
  {
    path: 'laboratory',
    loadChildren: () => Promise.resolve(LaboratoryModule)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: useHashRouting })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
